// extracted by mini-css-extract-plugin
export default {"departments":"xI-z","departmentHeading":"yI-z","departmentSection":"zI-z","departmentName":"AI-z","departmentLink":"BI-z","expandIcon":"CI-z"};